import { Component } from '@angular/core';
import { NotificationDto, NotificationModel, NotificationType } from '@sestek/notification';
import { ProjectExportedNotificationModel } from '../models/project-exported-notification-model';
import { LocalizationService } from '@abp/ng.core';
import { ToasterService } from '@abp/ng.theme.shared';
import { FileDownloadHelperService } from 'src/app/shared/services/file-download-helper.service';

import { DateFormatterPipe } from 'src/app/shared/pipes/date-formatter.pipe';
import { DateDisplayType } from 'src/app/shared/enums/date-display-type';
import { ProjectService } from 'src/app/projects/proxy/project.service';
import { ZIP_FILE_EXTENSION_NAME } from '@utils';

@Component({
  selector: 'cai-project-exported-notification',
  templateUrl: './project-exported-notification.component.html',
  styleUrls: ['./project-exported-notification.component.scss'],
  standalone: false,
})
@NotificationType('ProjectExportedNotification')
export class ProjectExportedNotificationComponent {
  _data: NotificationDto;

  get data() {
    return this._data;
  }
  set data(data: NotificationDto) {
    this._data = data;
    this.notification = JSON.parse(data.payload);
  }

  notification: ProjectExportedNotificationModel;

  constructor(
    private projectService: ProjectService,
    private localizationService: LocalizationService,
    private toasterService: ToasterService,
    private fileDownloadHelperService: FileDownloadHelperService,
    private dateFormatterPipe: DateFormatterPipe,
  ) {}

  showNotification(notification: NotificationModel) {
    this.notification = JSON.parse(notification.payload);

    const message = this.localizationService.instant('Project::ProjectExportIsReady');

    this.toasterService.success(message);

    const payload = JSON.parse(notification.payload);
    if (payload.showIntegrationWarning) {
      const warningMessage = `${this.localizationService.instant(
        'Project::ProjectExportIntegrationWarning',
      )}`;
      this.toasterService.warn(warningMessage, null, { sticky: true });
    }

    if (payload.showExternalToolsWarning) {
      const warningMessage = `${this.localizationService.instant(
        'Project::ProjectExportExternalToolsWarning',
      )}`;
      this.toasterService.warn(warningMessage, null, { sticky: true });
    }

    if (payload.showGuardrailWarning) {
      const warningMessage = `${this.localizationService.instant(
        'Project::ProjectExportGuardrailWarning',
      )}`;
      this.toasterService.warn(warningMessage, null, { sticky: true });
    }

    if (payload.showKnovvuAnalyticsSettingWarning) {
      const warningMessage = `${this.localizationService.instant(
        'Project::ProjectExportKnovvuAnalyticsSettingWarning',
      )}`;
      this.toasterService.warn(warningMessage, null, { sticky: true });
    }
  }
  downloadFile() {
    let nowString = this.dateFormatterPipe.transform(
      new Date(),
      DateDisplayType.shortDateShortTime,
    );

    nowString = nowString.replace(/[^a-zA-Z0-9]/g, '_');

    const fileName = `${this.notification.project}_${nowString}${ZIP_FILE_EXTENSION_NAME}`;

    this.projectService.getProjectExport(this.notification.fileId).subscribe(
      (result) => {
        this.fileDownloadHelperService.handleDownloadFileResult(result, fileName);
      },
      (error) => {
        this.fileDownloadHelperService.handleDownloadFileError(error);
      },
    );
  }
}
